/**
 * Pre-compiled de messages for ComboBox
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  clearSelection: `Auswahl löschen`,
  options: `Optionsmenü`,
  selectedValues: `Ausgewählte Werte`,
  toggleOptions: `Optionen anzeigen/ verbergen`,
};
